import { Bar } from "react-chartjs-2";
import { roundCount } from "../../../_app/utils/format";
import { createStylesheet } from "../../../_app/utils/styles";
import { Query } from "../../../filter/types";
import { useCallCount, useVerticalBarChartOptions } from "../../hooks";
import GraphWidget from "./GraphWidget";

interface Props {
  queries: Query[];
}

const CallCount = ({ queries }: Props) => {
  const classes = useStyles();
  const { data = [], isFetching, isError } = useCallCount(queries);
  const hasError = isError || data?.datasets?.length <= 0;
  const options = useVerticalBarChartOptions(
    undefined,
    (value: any) => roundCount(value, 0),
    (context: any) => {
      if (context.parsed.y !== null) {
        return roundCount(context.parsed.y);
      }
      return "";
    },
  );

  return (
    <GraphWidget title="Call Count" isLoading={isFetching} hasError={hasError}>
      <div className={classes.horizontalBarWrap}>
        <Bar data={data} options={options} />
      </div>
    </GraphWidget>
  );
};

const useStyles = createStylesheet(() => ({
  horizontalBarWrap: {
    position: "relative",
    minHeight: 410,
    width: "100%",
  },
}));

export default CallCount;
